export default {
    data() {
        return {
            eventListeners: [],
        }
    },

    beforeDestroy() {
        this.eventListeners.forEach(hook => {
            hook.element.removeEventListener(hook.event, hook.handle)
        })
    },

    methods: {
        listen(element, event, handle) {
            element.addEventListener(event, handle)

            this.eventListeners.push({ element, event, handle })
        },
    },
}
